export default __webpack_public_path__ + "6265037b606e3693cb3473f9193f9b66.jpg";